import Checkbox from '@/components/Form/Checkbox';
import Image from '@/components/Image';
import PrivacyPolicyDialog from '@/components/GlobalDialog/PrivacyPolicy';
import TermsConditionsDialog from '@/components/GlobalDialog/TermsConditionsDialog';
import { useStore } from '@/providers/app-store-provider';
import { env } from '@/utils/env';
import { useState } from 'react';
import { IS_DE_FR } from '@/utils/constants';

interface RightsImageWithAgreementProps {
  privacyPolicy: boolean;
  onPrivacyPolicyChange: (checked: boolean) => void;
}

export default function RightsImageWithAgreement({
  privacyPolicy,
  onPrivacyPolicyChange,
}: RightsImageWithAgreementProps) {
  const userInfo = useStore((state) => state.userInfo);
  const [privacyPolicyDialogShow, setPrivacyPolicyDialogShow] = useState(false);
  const [termsConditionsDialogShow, setTermsConditionsDialogShow] = useState(false);

  // wap端只有美国站展示权益同意复选框
  // 只有美国站且用户未同意过短信营销协议时才显示
  const shouldShowAgreement =
    env.NEXT_PUBLIC_SITE_NAME === 'us' && userInfo?.order_payment_marketing_notification !== 1;

  return (
    <>
      <section className="mt-12 mb-16">
        {/* 只有美国站才显示此复选框 */}
        {shouldShowAgreement && (
          <div className="mb-16">
            <Checkbox
              label={
                <div className="text-[12px] leading-[14px] text-[#808080]">
                  I would like to receive texts from Zeelool (Yes, I agree to these terms). By
                  checking this box, I provide my signature consenting to receive recurring
                  automated promotional and personalized marketing text messages from Zeelool at the
                  cell number used when signing up. Consent is not a condition of any purchase.
                  Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may
                  apply.
                </div>
              }
              checked={privacyPolicy}
              onChange={(e) => {
                onPrivacyPolicyChange(e.target.checked);
              }}
              sx={{
                alignItems: 'flex-start',
                '& .MuiFormControlLabel-label': {
                  marginTop: 0,
                },
                '.MuiCheckbox-root': {
                  paddingTop: '0 !important',
                },
              }}
            />
          </div>
        )}
        <Image
          src={IS_DE_FR ? '/payment/quanyi-mobile{locale}.png' : '/payment/quanyi-mobile.png'}
          alt="privacy policy"
          width={400}
          height={100}
          className="w-full"
        />
        {/* 只有美国站显示协议文本 */}
        {shouldShowAgreement && (
          <div className="text-[12px] leading-[14px] text-[#808080] mt-16">
            By proceeding to payment you agree to Zeelool&apos;s{' '}
            <span
              className="underline cursor-pointer text-[#282828]"
              onClick={() => setTermsConditionsDialogShow(true)}
            >
              Conditions of Use & Sale
            </span>
            ,{' '}
            <span
              className="underline cursor-pointer  text-[#282828]"
              onClick={() => setPrivacyPolicyDialogShow(true)}
            >
              Privacy Notice
            </span>{' '}
            and{' '}
            <span
              className="underline cursor-pointer text-[#282828]"
              onClick={(event) => {
                if (env.NEXT_PUBLIC_ENABLE_ONETRUST === 'true') {
                  event.preventDefault();
                  window?.OneTrust?.ToggleInfoDisplay();
                }
              }}
            >
              Cookies & Internet Advertising
            </span>
            , and consent to receive email with news and offers about our products.
          </div>
        )}
      </section>

      {privacyPolicyDialogShow && (
        <PrivacyPolicyDialog
          show={privacyPolicyDialogShow}
          onClose={() => setPrivacyPolicyDialogShow(false)}
        />
      )}
      {termsConditionsDialogShow && (
        <TermsConditionsDialog
          show={termsConditionsDialogShow}
          onClose={() => setTermsConditionsDialogShow(false)}
        />
      )}
    </>
  );
}
